var map = {
	"./777.png": 8178,
	"./888.png": 4395,
	"./betsafe.png": 6909,
	"./betway.png": 8089,
	"./casino-joy.png": 3115,
	"./casino.com.png": 3915,
	"./casoola.png": 1139,
	"./casumo.png": 6439,
	"./genesis.png": 1385,
	"./genting.png": 1217,
	"./hippo-drome-online.png": 615,
	"./hippodromeonline.png": 693,
	"./jackpot-city.png": 3965,
	"./jackpotcity.png": 428,
	"./jackpotcitycasino.png": 2221,
	"./leovegas.png": 4585,
	"./live-roulette.png": 168,
	"./manison.png": 7732,
	"./mobile-wins.png": 7233,
	"./slots-magic.png": 7146,
	"./slotsmagic.png": 5111,
	"./spin.png": 8267,
	"./spincasino.png": 4486,
	"./vegas-hero.png": 5592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7748;